// src/broadcast/schemas/events/message.schema.ts

import { z } from 'zod'
import { createBroadcastPayloadSchema } from '../base.schema'

/**
 * Schema for media items
 */
export const MediaItemSchema = z.object({
  type: z.enum(['image', 'video', 'audio', 'file', 'live']),
  thumbnail_url: z.string().optional(),
  full_url: z.string(),
  metadata: z.record(z.unknown()).optional(),
  creator_id: z.string(),
})

/**
 * Schema for message media container
 */
export const MessageMediaSchema = z.object({
  id: z.string(),
  creator_id: z.string(),
  items: z.array(MediaItemSchema),
})

/**
 * Schema for message records
 */
export const MessageRecordSchema = z.object({
  message_id: z.string(),
  type: z.enum(['Composition', 'Message', 'Media']),
  sub_type: z.string().nullable(),
  creator_id: z.string(),
  conversation_id: z.string(),
  content: z.string().optional(),
  created_at: z.string(),
  updated_at: z.string().optional(),
  message_media: MessageMediaSchema.nullable().optional(),
  is_read: z.boolean().optional(),
  is_deleted: z.boolean().optional(),
})

/**
 * Complete message broadcast payload schema
 */
export const MessageBroadcastPayloadSchema = createBroadcastPayloadSchema(
  MessageRecordSchema,
  z.literal('message')
)

/**
 * Inferred type from schema (for verification)
 */
export type MessageBroadcastPayloadFromSchema = z.infer<typeof MessageBroadcastPayloadSchema>
